import React from "react";
import { FastField } from "formik";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";

function CheckboxField({ label, className, category, fullWidth = true, ...props }) {
  return (
    <FormControl fullWidth={fullWidth}>
      <FormControlLabel
        sx={{ mb: 0 }}
        className={className}
        control={
          <FastField type="checkbox" {...props}>
            {({ field }) => (
              <Checkbox
                {...field}
                sx={{ p: 1, ...props.sx }}
                onChange={e =>
                  field.onChange({
                    ...e,
                    target: {
                      ...e.target,
                      name: field.name,
                      value: e.target.checked,
                    },
                  })
                }
                {...props}
              />
            )}
          </FastField>
        }
        label={
          <Typography color="text.primary" variant="body1">
            {label}
          </Typography>
        }
      />
    </FormControl>
  );
}

export default React.memo(CheckboxField);
